import React from 'react';

import * as S from './styles';

const Header: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <S.Title
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
        >
          O mundo
          <br />
          pelas
          <br />
          multilentes de
          <br />
          Manu Gavassi
        </S.Title>
        <S.TextWrapper
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="400ms"
        >
          <S.Text>
            Prestes a estrear uma série na Netflix e sair em turnê nacional,
            <br />a artista se tornou a nova embaixadora da Vogue Eyewear.
            <br />
            Aqui, conversamos sobre como ela enxerga o mundo direto do olho
            <br />
            do furacão.
          </S.Text>
          <S.Credits>
            <span>fotos:</span> Pedro Napolinário
            <br />
            <span>Direção de vídeo:</span> Fabrício Barreto
            <br />
            <span>Edição de moda:</span> Marcell Maia
            <br />
            <span>Texto:</span> PEDRO CAMARGO
          </S.Credits>
        </S.TextWrapper>
      </S.Wrapper>
      <S.Photo1
        className="wow animate__animated animate__fadeIn"
        data-wow-duration="1s"
        data-wow-delay="600ms"
      />
      <S.PhotoMobile1
        className="wow animate__animated animate__fadeIn"
        data-wow-duration="1s"
        data-wow-delay="600ms"
      />
    </S.Container>
  );
};

export default Header;
